import DatePicker from 'react-datepicker';
import Moment from 'moment';
import Translator from '../../../../components/helpers/Translator';

const Report23Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, values } = props;

  return (
    <>
      <div className="row">
        <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
          <label className="col-form-label">
            <Translator
              file="module-intelligence"
              name="module.int.xls.usedFilter-range"
            />
          </label>
        </div>
        <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div className="row">
                <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                  <label className="col-form-label">
                    <Translator
                      file="module-lawFinder"
                      name="module.lf.filter.from"
                    />
                  </label>
                </div>
                <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                  <DatePicker
                    locale="es"
                    selected={
                      values.from && Moment(values.from, 'MM/YYYY').toDate()
                    }
                    onChange={(opt) =>
                      handleOnSetFieldValue(
                        'from',
                        Moment(opt).format('MM/YYYY')
                      )
                    }
                    showMonthYearPicker
                    dropdownMode="select"
                    dateFormat="MM/yyyy"
                    className="mb-3"
                    placeholderText="mm/yyyy"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div className="row">
                <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                  <label className="col-form-label">
                    <Translator
                      file="module-lawFinder"
                      name="module.lf.filter.to"
                    />
                  </label>
                </div>
                <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                  <DatePicker
                    locale="es"
                    selected={
                      values.to && Moment(values.to, 'MM/YYYY').toDate()
                    }
                    onChange={(opt) =>
                      handleOnSetFieldValue('to', Moment(opt).format('MM/YYYY'))
                    }
                    showMonthYearPicker
                    dropdownMode="select"
                    dateFormat="MM/yyyy"
                    className="mb-3"
                    placeholderText="mm/yyyy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {!values.from ||
          values.from.length === 0 ||
          !values.to || values.to.length === 0 ? (
            <span className="btn btn-info btn-block disabled">
              <Translator
                file="module-intelligence"
                name="module.int.btn.generate"
              />
            </span>
          ) : (
            <span
              className="btn btn-info btn-block"
              onClick={() => handleOnSubmit()}
            >
              <Translator
                file="module-intelligence"
                name="module.int.btn.generate"
              />
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default Report23Options;
